import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";
import { LOCAL_STORAGE_KEYS } from "../global/constants";
import { LocalStorageService } from "./local-storage.service";
import { BulkPayrollResponse } from "./transaction/schedule.service";

@Injectable({
  providedIn: "root",
})
export class DataTransferService {
  currencySymbol: any;
  walletBalance: number;

  constructor(private localStorage: LocalStorageService) {
    if (!this.currencySymbol) {
      this.localStorage
        .getDataFromIndexedDB(LOCAL_STORAGE_KEYS.CURRENCY_SYMBOL)
        .then((data) => {
          this.currencySymbol = data;
        });
    }
    if (this.walletBalance == null) {
      this.localStorage
        .getDataFromIndexedDB(LOCAL_STORAGE_KEYS.WALLET_BALNCE)
        .then((data) => {
          this.walletBalance = data as number;
        });
    }
  }
  changeTitle(title: string) {
    this.titleSub.next(title);
  }
  titleSub = new BehaviorSubject("Home");
  titleObs = this.titleSub.asObservable();

  transactionDoneFromSub = new BehaviorSubject(null);
  transactionDoneFromObs = this.transactionDoneFromSub.asObservable();

  headerBackBtnSub = new Subject<any>();
  headerBackBtnObs = this.headerBackBtnSub.asObservable();

  displayNewChatBtnSub = new Subject<any>();
  displayNewChatBtnObs = this.displayNewChatBtnSub.asObservable();

  currentChatUsersSub = new BehaviorSubject(null);
  currentChatUsersObs = this.currentChatUsersSub.asObservable();

  activeChatSub = new BehaviorSubject(null);
  activeChatObs = this.activeChatSub.asObservable();

  // { balance, explorePoints, userId }
  walletUpdateSub = new BehaviorSubject(null);
  walletUpdateObs = this.walletUpdateSub.asObservable();

  bulkPayrollResultSub = new BehaviorSubject<BulkPayrollResponse | null>(null);
  bulkPayrollResultObs = this.bulkPayrollResultSub.asObservable();
}
